import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { PATH } from '../../../../../constants/path';
import {
    APP_NAME,
    HAS_INSTANT_DISCOUNT,
    NO_DISCOUNT,
    REDIRECT_URL,
    USE_PARITY
} from '../../../../../constants';

import { doRewriteUrl } from '../../../../../services/interstitiel/actions';

import { getI18nByApp } from '../../../../../services/i18n/selector';

import { formatAmountCurrency, formatAmountParity, redirectParent } from '../../../../../utils';
import { convertHtmlToReactDomWithParams } from '../../../../../utils/htmlUtils';

import LinkButtonComponent from '../../../../button/LinkButtonComponent';

import { MessageContainer } from './ConfirmationEbonPageMessageBlocStyle';

const FreeValueBloc = ({
    partnerName,
    sessionEmail,
    urlRewritten,
    redirectUri,
    redirectLabel,
    amount,
    i18n
}) => {
    const cashbackAmount = USE_PARITY ? formatAmountParity(amount) : formatAmountCurrency(amount);

    return (
        <div>
            <h1>{getI18nByApp(i18n, 'page.EBON.CONFIRMATION.TITLE')}</h1>

            <MessageContainer>
                <h3>{getI18nByApp(i18n, 'page.EBON.CONFIRMATION.FREE_FACIAL_VALUE.TEXT_1')}</h3>
                <p>
                    {sessionEmail
                        ? convertHtmlToReactDomWithParams(
                              getI18nByApp(i18n, 'page.EBON.CONFIRMATION.FREE_FACIAL_VALUE.TEXT_2'),
                              sessionEmail
                          )
                        : getI18nByApp(i18n, 'page.EBON.CONFIRMATION.FREE_FACIAL_VALUE.TEXT_2_ALT')}
                </p>

                {!NO_DISCOUNT && !HAS_INSTANT_DISCOUNT && !!amount && amount > 0 && (
                    <p>
                        {convertHtmlToReactDomWithParams(
                            getI18nByApp(i18n, 'page.EBON.CONFIRMATION.FREE_FACIAL_VALUE.TEXT_3'),
                            cashbackAmount,
                            APP_NAME
                        )}
                    </p>
                )}

                <p>{getI18nByApp(i18n, 'page.EBON.CONFIRMATION.SPAM_MESSAGE')}</p>

                {HAS_INSTANT_DISCOUNT && urlRewritten && (
                    <p>
                        {convertHtmlToReactDomWithParams(
                            getI18nByApp(i18n, 'page.EBON.CONFIRMATION.REDIRECT_MERCHANT_WEBSITE'),
                            partnerName,
                            urlRewritten
                        )}
                    </p>
                )}
            </MessageContainer>

            {REDIRECT_URL ? (
                <p>
                    <a
                        href={REDIRECT_URL}
                        rel={'external'}
                        onClick={e => {
                            e.preventDefault();
                            redirectParent(REDIRECT_URL);
                        }}
                    >
                        {convertHtmlToReactDomWithParams(
                            getI18nByApp(i18n, 'page.EBON.CONFIRMATION.REDIRECT'),
                            REDIRECT_URL.replace('https://', '').replace('http://', '')
                        )}
                    </a>
                </p>
            ) : redirectUri ? (
                <p>
                    <a href={redirectUri} rel={'external'}>
                        {convertHtmlToReactDomWithParams(
                            getI18nByApp(i18n, 'page.EBON.CONFIRMATION.REDIRECT'),
                            redirectLabel
                        )}
                    </a>
                </p>
            ) : (
                <LinkButtonComponent
                    to={PATH.HOME_PATH}
                    text={getI18nByApp(i18n, 'page.EBON.CONFIRMATION.REDIRECT_HOME')}
                    title={getI18nByApp(i18n, 'page.EBON.CONFIRMATION.REDIRECT_HOME')}
                    color="main"
                />
            )}
        </div>
    );
};

FreeValueBloc.propTypes = {
    partnerName: PropTypes.string,
    sessionEmail: PropTypes.string,
    urlRewritten: PropTypes.string,
    redirectUri: PropTypes.string,
    redirectLabel: PropTypes.string,
    amount: PropTypes.number
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n
    };
};

const mapDispatchToProps = {
    doRewriteUrl
};

export default connect(mapStateToProps, mapDispatchToProps)(FreeValueBloc);



// WEBPACK FOOTER //
// ./src/components/pages/ebon/confirmation/message/FreeValueBloc.js